// extracted by mini-css-extract-plugin
export default {"space":"loader_space__1SoBo","spin":"loader_spin__1-Dpg","icon":"loader_icon__63s28"};